module.exports = __webpack_public_path__ + "img/mock-up-big.5dfe4496.png";